import './styles/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './views/Home.js';

function App() {
  return (
    <body>
      <Home />
    </body>
  );
}

export default App;
